<template>
    <div>
      <div class="nav">
              <ul class="list3">
                  <li><el-button size="large" color="#e8f2ff" tag="a" href="/"><el-icon><House /></el-icon>首页</el-button></li>
                  <li><el-button  size="large" color="#e8f2ff" tag="a" href="/gkzl"><el-icon><Coin /></el-icon>高考资料</el-button></li>
                  <li><el-button size="large" color="#e8f2ff" tag="a" href="/zkjc"><el-icon><Reading /></el-icon>自考教材</el-button></li>
                  <li><el-button  size="large" color="#e8f2ff" tag="a" href="/sfjc"><el-icon ><EditPen /></el-icon>书法教材</el-button></li>
                  <li><el-button size="large"  color="#e8f2ff" tag="a" href="/bkzz"><el-icon ><DocumentCopy /></el-icon>报刊杂志</el-button></li>
                  <li><el-button size="large" color="#e8f2ff" tag="a" href="/tjts"><el-icon ><CollectionTag /></el-icon>特价图书</el-button></li>
                  <li><el-button size="large" type="primary"  color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/cjzs"><el-icon style="color: #ffffff;"><Notebook /></el-icon>成绩证书</el-button></li>
                  <li><el-button size="large" color="#e8f2ff" tag="a" href="/others"><el-icon><Menu /></el-icon>其他</el-button></li>
              </ul>
          </div>
          <div class="search">
              <el-input placeholder="请输入教材名称搜索"  size="large" v-model="input" :prefix-icon="Search"></el-input>
              <el-button style="background-color:#49aef1 ;" @click="search(input)">搜索</el-button>
          </div>
          <div class="before">
        <div class="tags">
            <div style="width: 7px;height: 7px;background-color: orange;"></div>
            <div style="width: 7px;height: 33px;background-color:#49aef1 ; margin-top: 6px;"></div>
            <div class="tag1">热销图书</div>
            <div class="triangle"></div>
            <div class="tag"></div>
            <a href="/hotmore/热销/成绩证书" class="more">MORE+</a>
            <hr>
        </div>
        <div class="book">
            <ul class="list4">
                <li v-for="item in hotBooks" :key="item.ID" >
                   <a @click="getBookId(item.ID)"> <div class="bookImg"><el-image v-if="item.IMG_COVER" :src="item.IMG_COVER[0]" /></div><p class="bookTitle">{{ item.NAME }}</p><p class="bookPrice"><span>￥</span>{{ item.PRICE }}</p></a>
                </li>
            </ul>
        </div>
        <div class="tags">
            <div style="width: 7px;height: 7px;background-color: orange;"></div>
            <div style="width: 7px;height: 33px;background-color:#49aef1 ; margin-top: 6px;"></div>
            <div class="tag1">成绩证书</div>
            <div class="triangle"></div>
            <div class="tag"></div>
            <a href="/bookmore/非热销/成绩证书" class="more">MORE+</a>
            <hr>
        </div>
        <ul class="list5">
                <li v-for="item in books" :key="item.ID" >
                   <a @click="getBookId(item.ID)"> <div class="bookImg"><el-image v-if="item.IMG_COVER" :src="item.IMG_COVER[0]" /></div><p class="bookTitle">{{ item.NAME }}</p><p class="bookPrice"><span>￥</span>{{ item.PRICE }}</p></a>
                </li>
            </ul>
            </div>
        <div class="after">
            <div class="tags">
            <div style="width: 7px;height: 7px;background-color: orange;"></div>
            <div style="width: 7px;height: 33px;background-color:#49aef1 ; margin-top: 6px;"></div>
            <div class="tag1">搜索结果</div>
            <div class="triangle"></div>
            <div class="tag"></div>
            <hr>
            </div>
            <ul class="list5">
                <li v-for="item in searchBooks" :key="item.ID" >
                   <a @click="getBookId(item.ID)"> <div class="bookImg"><el-image v-if="item.IMG_COVER" :src="item.IMG_COVER[0]" /></div><p class="bookTitle">{{ item.NAME }}</p><p class="bookPrice"><span>￥</span>{{ item.PRICE }}</p></a>
                </li>
            </ul>
        </div>          
    </div>
  </template>
  
  <script >
  import {ref} from 'vue'
  import {Search} from '@element-plus/icons-vue'
  
  export default {
      name: "CJZS",
      setup(){
          const input = ref('')
          return{
              input,
              Search
          }
      },
      methods: {
        getCJZS(){
            this.$axios.post('/api/Book/Booklist',{
                category: '成绩证书'
            }).then(res=>{
                res.data.hot.forEach(item => {
                    item.IMG_COVER = item.IMG_COVER.split(',');
                })
                res.data.nothot.forEach(item => {
                    item.IMG_COVER = item.IMG_COVER.split(',');
                })
                this.hotBooks = res.data.hot
                this.books = res.data.nothot
            })
        },
        getBookId(id){
                const url = '/cjzsdetail/'+id;
                window.open(url);
            },
        search(name){
            if(name == ''){
                this.$message({
                    message: '请输入搜索内容',
                    type: 'warning'
                })
                return
            }
            this.$axios.post('/api/Book/BookSearch',{
                name: name,
                category: '成绩证书'
            }).then(res => {
                res.data.forEach(item => {
                    item.IMG_COVER = item.IMG_COVER.split(',');
                })
                this.searchBooks = res.data
            })
            //使after显示并隐藏before
            document.querySelector('.before').style.display = 'none';
            document.querySelector('.after').style.display = 'block';
        }        
    },
    data(){
        return{
            hotBooks: [],
            books: [],
            searchBooks: []
        }
    },
    created(){
        this.getCJZS();
    }
  }
  </script>
  
  <style scoped>
  .after{
      display: none;
  }
  .list5{
      list-style-type: none;
      float: left;
      margin-left: 225px;
      margin-top: 20px;
      height: 1200px;
      width: 1350px;
  }
  .list5 li{
      float: left;
      width: 270px;
      height: 380px;
      padding-left: 25px;
      margin-top: 20px;
      border-radius: 6px;
  }
  .list5 .el-image{
      width: 150px;
      height: 190px;
      margin-top: 20px;
  }
  .list5 li a{
      text-decoration: none;
      color: #464545;
  }
  .list5 li:hover{
      box-shadow: 0 0 10px #ccc;
  }
  .list5 li:hover .bookImg{
      border: rgb(204, 199, 199);
  }
  .list4 li a{
      text-decoration: none;
      color: #464545;
  }
  .list4 li:hover{
      box-shadow: 0 0 10px #ccc;
  }
  .list4 li:hover .bookImg{
      border: rgb(204, 199, 199);
  }
  .bookPrice{
      margin-top: 20px;
      color: #db444a;
      font-size: 25px;
      font-weight: bold;
      margin-right: 50px;
  }
  .bookPrice span{
      font-size: 16px;
      font-weight: bold;
  }
  .bookTitle{
      width: 210px;
      height: 40px;
      margin-top: 20px;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre-wrap;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
  }
  .bookImg{
      width: 220px;
      height: 230px;
      border: rgb(204, 199, 199) solid 1px;
      border-radius: 6px;
  }
  .list4{
      list-style-type: none;
      float: left;
      margin-left: 225px;
      margin-top: 20px;
      height: 400px;
  }
  .list4 li{
      float: left;
      width: 270px;
      height: 380px;
      padding-left: 25px;
      margin-top: 20px;
      border-radius: 6px;
  }
  .list4 .el-image{
      width: 150px;
      height: 190px;
      margin-top: 20px;
  }
  .more{
      float: right;
      margin-right: 300px;
      margin-top: -29px;
      color: #79838a;
  }
  hr{
      width: 1160px;
      margin-left: 140px;
      margin-top: -2px;
      border: 1px solid #efefef;
  }
  .tags{
      width: 1600px;
      float: left;
      height: 46px;
      margin-left: 250px;
      margin-top: 10px;
  }
  .tag1{
      font-size: 20px;
      color: #ffffff;
      width: 110px;
      height: 46px;
      margin-top: -46px;
      margin-left: 15px;
      position: relative;
      padding-top: 10px;
      background: linear-gradient(to top, #47a8f3,#6ac7f8);
  }
  .triangle{
      width: 25px;
      height: 46px;                                       
      margin-left: 125px;
      clip-path: polygon(0 0, 0 100%, 50% 100%);
      margin-top: -46px;
      background: linear-gradient(to top, #47a8f3,#6ac7f8)
  }
  .tag{
      width: 800px;
      float: left;
      height: 26px;
      margin-left: 138px;
      background-color: #efefef;
      margin-top: -35px;
      background: repeating-linear-gradient(145deg, white, white 2px, #efefef 2px, #efefef 4px) ;
      mask-image: linear-gradient(to left, transparent 0%, black 60%);
      transform: skew(19deg);
  }
  .search .el-button{
      width: 140px;
      height: 46px;
      font-size: 16px;
      float: left;
      margin-top: 10px;
      margin-left: -10px;
      background-color: #49aef1;
      color: #ffffff;
  }
  .el-input{
      float: left;
      width: 530px;
      height: 46px;
      margin-left: 250px;
      margin-top: 10px;
      margin-bottom: 20px;
      color: #f5f6f6;
  }
  .el-icon{
      font-size: 25px;
      margin-right: 10px;
      color: #49aef1;
  }
  
  .list3 .el-button{
      width: 161px;
      height: 46px;
      font-size: 16px;
      border-radius: 7px;
      color: #000;
      margin-top: 1px;
      padding-left: 10px;
      background: linear-gradient(to top, #deedff,#f3f8ff);
  }
  .list3 {
      list-style-type: none;
      float: left;
      margin-left: 240px;
      margin-top: 5px;
      height: 60px;
  }
  
  .list3 li {
      float: left;
      font-size: 20px;
      margin-left: 20px;
      width: 165px;
      height: 50px;
      font-weight: bold;
      border-radius: 7px;
      display: block;
      color: #49aef1;
      border: #c3d1db solid 1px;
  }
  .list3 a{
      text-decoration: none;
      color: #49aef1;
  }
  .el-button:hover {
      background: linear-gradient(to top, #47a8f3,#6ac7f8);
      color: #ffffff;
  }
  
  .el-button:hover .el-icon {
      color: #ffffff;
  }
  </style>
  

